"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileCollection = void 0;
class FileCollection {
    constructor(files) {
        this.files = files;
    }
    filter(callback) {
        return new FileCollection(this.files.filter(callback));
    }
    [Symbol.iterator]() {
        return this.files.values();
    }
}
exports.FileCollection = FileCollection;
//# sourceMappingURL=FileCollection.js.map